import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Only import HelmetProvider – DO NOT import BrowserRouter here
import { HelmetProvider } from 'react-helmet-async';

const container = document.getElementById('root');
const app = (
  <React.StrictMode>
    <HelmetProvider>
      <App />                 {/* App.jsx already contains <BrowserRouter> */}
    </HelmetProvider>
  </React.StrictMode>
);

// scripts/prerender.js (postbuild) bakes real, rendered HTML into each
// route's index.html. When that markup is already present, hydrate over it
// instead of wiping and re-rendering from scratch.
if (container.hasChildNodes()) {
  ReactDOM.hydrateRoot(container, app);
} else {
  ReactDOM.createRoot(container).render(app);
}

reportWebVitals();